import * as constants from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/config/constants.js';
import jQuery from 'jquery';
import 'whatwg-fetch';
window.$ = window.jQuery = jQuery;
import ClassList from 'classlist';
import ElementClassHandler from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/element-class-handler';

export default class {

    constructor(options = {}) {
        this.options = options;
        this.elementClassHandler = new ElementClassHandler;
        this.employmentStatus = document.querySelector(options.employmentStatusFormElement);
        this.timeWithEmployerLabel = document.querySelector(options.timeWithEmployerLabel);
        this.div = document.querySelector(options.jobTitleLabel).parentElement;
        this.labelMultiLineLimit = options.textBreakLimit || 25;
        this.labelMultiLineClass = options.labelWordBreakClass || constants.MDL_MULTILINE_LABEL_CLASS;
    }

    setup() {
        let list = ClassList(this.div);

        this.employmentStatus.addEventListener('change', () => {
            this.displayWhenSelected(this.employmentStatus, 'employed', list);
        });

        if (this.employmentStatus.value === 'employed') {
            list.remove('hidden');
        } else {
            list.add('hidden');
        }

        this.timeWithEmployerLabel.textContent = this.labelMapper(this.employmentStatus.value);

        fetch(constants.CHECKOUTPATH + '/ajax/job-titles.json')
            .then(response => response.json())
            .then((json) => {
                const source = this.substringMatcher(json);

                $('.typeahead').typeahead({
                    local: 'jobTitles',
                    hint: true,
                    highlight: true,
                    minLength: 1
                },
                {
                    name: 'jobTitles',
                    source: source
                });
            })
            .catch(function(err) {
                console.error('Fetch Error :-', err);
            });
        componentHandler.upgradeElement(this.div);
    }

    substringMatcher(jobTitles) {
        return function findMatches(q, cb) {
            cb(jobTitles.filter(j => j.toLowerCase().includes(q.toLowerCase())));
        };
    }

    displayWhenSelected(source, value, target) {
        const selectedIndex = source.selectedIndex;
        const isSelected = source[selectedIndex].value === value;
        let labelText = this.labelMapper(source[selectedIndex].value);

        if (isSelected) {
            target.remove('hidden');
            target.add('is-dirty');
            componentHandler.upgradeElement(this.div);
        } else {
            target.add('hidden');
        }

        this.timeWithEmployerLabel.textContent = labelText;

        if (labelText.length > this.labelMultiLineLimit) {
            this.elementClassHandler.add(this.timeWithEmployerLabel, this.labelMultiLineClass);
        } else {
            this.elementClassHandler.remove(this.timeWithEmployerLabel, this.labelMultiLineClass);
        }
    }

    labelMapper(employmentStatus = '') {
        return (employmentStatus == '') ? 'Time with employer?' : 'Time with employer?';
    }
}
